import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { WidgetDefinition, WidgetRegistryService } from '@sdbn/common';
import { GateKeeperControlWidgetComponent } from './gate-keeper-control-widget/gkc-widget.component';
import { GateKeepingComponentsModule } from '../components/gate-keeping-components.module';
import { GKCFindElementByLprComponent } from '../components/gate-keeper-control/gkc-find-element-dialog/gkc-find-element-by-lpr/gkc-find-element-by-lpr.component';



@NgModule({
  declarations: [
    GateKeeperControlWidgetComponent
  ],
  imports: [
    CommonModule,
    GateKeepingComponentsModule
  ],
  exports: [
    GKCFindElementByLprComponent
  ]
})
export class GateKeepingWidgetsModule {

  constructor(
    private widgetRegistryService: WidgetRegistryService
  ) {

    widgetRegistryService.registerWidget(new WidgetDefinition({ key: 'gateKeeperControl', name: 'Gate Keeper Control', description: 'TBD', icon: 'fa-light fa-users-class', groupIdentifier: 'reports', widgetComponent: GateKeeperControlWidgetComponent, editorComponent: null, autoreload: true }));

  }


}
